import "./Slider.scss";
import React from "react";
import ReactSlider from "react-slider";
import { useDispatch } from "react-redux";

const Slider = React.memo((props) => {
  const dispatch = useDispatch();
  return (
    <div className="Slider">
      <ReactSlider
        value={props.value}
        min={props.min}
        max={props.max}
        step={props.step}
        className="horizontal-slider"
        thumbClassName="horizontal-slider-thumb"
        trackClassName="horizontal-slider-track"
        onChange={(value) =>
          dispatch({
            ...props.action,
            payload: {
              ...props.action.payload,
              value,
            },
          })
        }
      />
    </div>
  );
});

export default Slider;
